module.exports = __webpack_public_path__ + "5728d7ff3edb2e7357500f8f512fae8f.gif";